import { useIsBehindFeatureFlag } from "./useFeatureFlag";

export const useCanDownloadExcel = () => {
  return useIsBehindFeatureFlag("plan_excel_download");
};
